var $09e6b82e0d6e466a$exports = {};
$09e6b82e0d6e466a$exports = {
  "select": "Select",
  "selectAll": "Select All",
  "sortable": "sortable column",
  "ascending": "ascending",
  "descending": "descending",
  "ascendingSort": function ascendingSort(args) {
    return "sorted by column ".concat(args.columnName, " in ascending order");
  },
  "descendingSort": function descendingSort(args) {
    return "sorted by column ".concat(args.columnName, " in descending order");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pixels");
  },
  "resizerDescription": "Press Enter to start resizing"
};
export { $09e6b82e0d6e466a$exports as default };